import { PROVIDERS } from "./constants";

export const normalizeProviderForDisplay = (provider: string): string => {
  if (provider.startsWith("openai.azure")) {
    return "openai.azure";
  }
  if (provider.startsWith("openai")) {
    return "openai";
  }
  if (provider.includes("anthropic")) {
    return "anthropic";
  }
  if (provider.includes("amazon.bedrock") || provider.includes("bedrock")) {
    return "amazon.bedrock";
  }
  if (provider.includes("google") || provider.includes("gemini")) {
    return "google";
  }
  return provider;
};

export const mapProviderToDisplayName = (provider: string): string =>
  PROVIDERS.find(p => p.apiName === provider)?.displayName ||
  PROVIDERS.find(p => p.apiName === normalizeProviderForDisplay(provider))?.displayName ||
  provider;
